(function () {
  if (window.__dyRecommendationLoaded) {
    return;
  }

  window.__dyRecommendationLoaded = true;

  class DyRecommendation extends HTMLElement {
    constructor() {
      super();
      this.flickity = null;
      this.slideshow = null;
      this.isUpdating = false;
      this.titleContainer = null;
      this.titleNode = null;
      this.reinitTimer = null;
      this.totalCardCount = 0;
      this.loadedCardCount = 0;
      this.onRemoteCardLoaded = this.onRemoteCardLoaded.bind(this);
    }

    static get observedAttributes() {
      return ["title"];
    }

    connectedCallback() {
      this.ensureMarkup();
      this.renderTitle();
      this.refreshSlides();
      this.hoistQuickShopModals(this);
      this.observeChildren();
      this.addEventListener(
        "remote-product-card:loaded",
        this.onRemoteCardLoaded
      );
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!this.isConnected || oldValue === newValue) {
        return;
      }

      if (name === "title") {
        this.renderTitle();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.reinitTimer) {
        window.clearTimeout(this.reinitTimer);
        this.reinitTimer = null;
      }

      this.removeEventListener(
        "remote-product-card:loaded",
        this.onRemoteCardLoaded
      );

      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }

      this.flickity = null;
    }

    ensureMarkup() {
      if (this.slideshow) {
        return;
      }

      var pageWidth = document.createElement("div");
      pageWidth.className = "page-width page-width--flush-small";

      var gridOverflow = document.createElement("div");
      gridOverflow.className = "grid-overflow-wrapper";

      var recommendations = document.createElement("div");
      recommendations.className = "product-recommendations page-width";

      var slider = document.createElement("div");
      slider.className = "product-single__related grid grid--uniform";
      slider.setAttribute("data-aos", "overflow__animation");
      slider.setAttribute("data-slideshow", "");

      recommendations.appendChild(slider);
      gridOverflow.appendChild(recommendations);
      pageWidth.appendChild(gridOverflow);
      this.appendChild(pageWidth);

      this.slideshow = slider;
    }

    renderTitle() {
      var title = (this.getAttribute("title") || "").trim();

      if (!title) {
        if (this.titleContainer) {
          this.titleContainer.remove();
          this.titleContainer = null;
          this.titleNode = null;
        }

        return;
      }

      if (!this.titleContainer) {
        var pageWidth = document.createElement("div");
        pageWidth.className = "page-width";

        var header = document.createElement("header");
        header.className = "section-header";

        var heading = document.createElement("h3");
        heading.className = "section-header__title";

        header.appendChild(heading);
        pageWidth.appendChild(header);

        this.insertBefore(pageWidth, this.firstChild);
        this.titleContainer = pageWidth;
        this.titleNode = heading;
      }

      this.titleNode.textContent = title;
    }

    observeChildren() {
      if (this.observer) {
        return;
      }

      this.observer = new MutationObserver((mutations) => {
        if (this.isUpdating) {
          return;
        }

        var shouldRefresh = mutations.some((mutation) => {
          var nodes = Array.from(mutation.addedNodes).concat(
            Array.from(mutation.removedNodes)
          );
          return nodes.some((node) => {
            if (node.nodeType !== 1) {
              return false;
            }

            if (node.matches && node.matches("remote-product-card")) {
              return true;
            }

            return Boolean(
              node.querySelector && node.querySelector("remote-product-card")
            );
          });
        });

        if (shouldRefresh) {
          this.refreshSlides();
        }
      });

      this.observer.observe(this, { childList: true });
    }

    refreshSlides() {
      if (!this.slideshow) {
        return;
      }

      var cards = Array.from(this.querySelectorAll("remote-product-card"));
      var controlType =
        this.getAttribute("controls") || this.dataset.controls || "dots";

      if (!cards.length) {
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
          this.flickity = null;
        }

        this.slideshow.innerHTML = "";
        this.totalCardCount = 0;
        this.loadedCardCount = 0;
        return;
      }

      this.isUpdating = true;
      this.slideshow.innerHTML = "";
      var fragment = document.createDocumentFragment();
      cards.forEach((card) => {
        fragment.appendChild(card);
      });
      this.slideshow.appendChild(fragment);
      this.isUpdating = false;

      this.slideshow.dataset.controls = controlType;
      this.slideshow.dataset.count = cards.length;
      this.totalCardCount = cards.length;
      this.loadedCardCount = 0;

      cards.forEach((card) => {
        card.__dyCardLoaded = card.children.length > 0;
        if (card.__dyCardLoaded) {
          this.loadedCardCount += 1;
        }
      });

      this.setupSlider();

      if (this.loadedCardCount >= this.totalCardCount) {
        this.scheduleReinit(0);
      }
    }

    setupSlider() {
      var controlType = this.slideshow.dataset.controls;
      var count = parseFloat(this.slideshow.dataset.count);

      var prevNextButtons = false;
      var pageDots = true;

      if (controlType === "arrows") {
        pageDots = false;
        prevNextButtons = true;
      }

      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
        this.flickity = null;
      }

      if (window.theme && typeof theme.Slideshow === "function" && count > 1) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons: prevNextButtons,
          pageDots: pageDots,
          adaptiveHeight: false,
          groupCells: true,
          cellAlign: "left",
          contain: true,
          wrapAround: false,
        });
      }
    }

    onRemoteCardLoaded(event) {
      var card =
        event.target && event.target.closest
          ? event.target.closest("remote-product-card")
          : null;

      if (card) {
        this.hoistQuickShopModals(card);
      }

      if (card && !card.__dyCardLoaded) {
        card.__dyCardLoaded = true;
        this.loadedCardCount += 1;
      }

      if (this.loadedCardCount >= this.totalCardCount) {
        this.scheduleReinit(0);
      } else {
        this.scheduleReinit(180);
      }
    }

    scheduleReinit(delay) {
      if (this.reinitTimer) {
        window.clearTimeout(this.reinitTimer);
      }

      this.reinitTimer = window.setTimeout(() => {
        this.reinitTimer = null;

        if (this.flickity && typeof this.flickity.resize === "function") {
          this.flickity.resize();
        }

        if (window.theme && typeof theme.reinitProductGridItem === "function") {
          theme.reinitProductGridItem(this);
        }

        document.dispatchEvent(
          new CustomEvent("recommendations:loaded", {
            detail: {
              section: this,
              intent: "dynamic-yield",
            },
          })
        );
      }, delay || 0);
    }

    hoistQuickShopModals(scope) {
      if (!scope || !document.body) {
        return;
      }

      var modals = Array.from(scope.querySelectorAll(".modal--quick-shop[id]"));
      if (!modals.length) {
        return;
      }
      var hoisted = window.__dyQuickShopModalStore;
      if (!hoisted) {
        hoisted = window.__dyQuickShopModalStore = new Map();
      }

      modals.forEach((modal) => {
        var existing = hoisted.get(modal.id);

        // If we already hoisted a modal with this id, remove duplicates.
        if (existing && existing !== modal) {
          modal.remove();
          return;
        }

        if (modal.dataset.dyHoisted === "true") {
          hoisted.set(modal.id, modal);
          return;
        }

        modal.dataset.dyHoisted = "true";
        document.body.appendChild(modal);
        hoisted.set(modal.id, modal);
      });
    }
  }

  if (!customElements.get("dy-recommendation")) {
    customElements.define("dy-recommendation", DyRecommendation);
  }
})();
